const dataSourcePortal = {
  header: {
    title: "Gátt gagnaveitenda",
    subtitle:
      "Skoðaðu gagnabeiðnir sem þér hafa verið framsendar og sendu inn gagnasöfn.",
  },
  tabs: {
    newRequests: "Nýjar beiðnir",
    newRequestsWithCount: "Nýjar beiðnir ({{n}})",
    accepted: "Samþykkt — innsending gagna vantar",
    acceptedWithCount: "Samþykkt — innsending gagna vantar ({{n}})",
    activityLog: "Aðgerðaskrá",
  },
  errors: {
    loadForwardedFailed: "Ekki tókst að sækja framsendar beiðnir",
    loadAcceptedFailed: "Ekki tókst að sækja samþykktar beiðnir",
    loadActivityFailed: "Ekki tókst að sækja aðgerðaskrá",
    loadDataFailed: "Ekki tókst að sækja gögn",
    acceptFailed: "Ekki tókst að samþykkja beiðni",
    declineFailed: "Ekki tókst að hafna beiðni",
  },
  meta: {
    researcher: "Rannsakandi:",
    forwardedBy: "Framsent af:",
    project: "Verkefni:",
    datasetId: "Auðkenni gagnasafns:",
  },
  labels: {
    requestedFields: "Umbeðnir dálkar:",
    filterCriteria: "Síunarskilyrði:",
    processingNotes: "Athugasemdir um vinnslu:",
    forwardingNote: "Athugasemd við framsendingu:",
    forwardedOn: "Framsent {{date}}",
    forwardedBySuffix: " af {{name}}",
  },
  badges: {
    requestNumber: "Beiðni #{{id}}",
  },
  actions: {
    processing: "Vinn úr…",
    canProvide: "Ég get útvegað þessi gögn",
    cannotProvide: "Get ekki útvegað gögn",
    uploadDataFile: "Senda inn gagnaskrá",
  },
  forwardedTab: {
    empty: "Engar beiðnir hafa verið framsendar til þín eins og er.",
  },
  acceptedTab: {
    empty: "Engar samþykktar beiðnir bíða innsendingar gagna.",
    emptyHint:
      "Eftir að þú samþykkir framsenda beiðni birtist hún hér svo þú getir sent inn gagnasafnið.",
  },
  activityTab: {
    empty: "Engin virkni hefur verið skráð enn.",
    headers: {
      request: "Beiðni",
      researcher: "Rannsakandi",
      dataset: "Gagnasafn",
    },
    confirmed: "Staðfest",
  },
};

export default dataSourcePortal;
